<script setup>
import { RouterLink } from 'vue-router';
</script>

<template>
    <footer class="site-footer">
        <p>
            Print in a Pinch partners with local printers for quick production while you choose the
            delivery method.
        </p>
        <nav>
            <RouterLink to="/privacy-policy" class="orange">Privacy Policy</RouterLink>
            <span class="separator">|</span>
            <RouterLink to="/terms-of-service" class="orange">Terms of Service</RouterLink>
            <span class="separator">|</span>
            <RouterLink to="/support" class="orange">Support</RouterLink>
        </nav>
    </footer>
</template>

<style scoped>
.site-footer {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid var(--color-border);
    text-align: center;
    font-size: 0.9rem;
    grid-column: 1 / -1;
}

nav {
    margin-top: 0.5rem;
}

.separator {
    margin: 0 0.75rem;
    color: var(--color-text-muted, #666);
    user-select: none;
}
</style>
